import { gql } from '@apollo/client';

export type LoadingArchiveTaskItem = {
  id: number | null;
  taskNumber: string | null;
  routeName: string | null;
  taskType: number | null;
  businessType: number | null;
  taskDate: string | null;
  taskStatus: number | null;
  archiveStatus: number | null;
  archivable: boolean;
  notArchivableReason: string | null;
  /** 任务日期在 2~3 个月前窗口内：已可归档但距今较近，归档按钮标红并二次确认 */
  riskyArchive: boolean;
};

export type LoadingArchiveTaskFilter = {
  taskId?: number;
  taskNumber?: string;
  taskStatus?: number;
  taskType?: number;
  taskDateFrom?: string;
  taskDateTo?: string;
};

export type LoadingOrderDetailItem = {
  id: number | null;
  tmsLoadingDetailId: number | null;
  taskId: number | null;
  waypointId: number | null;
  loadingTime: string | null;
  bagId: number | null;
  orderId: number | null;
  trackingNumber: string | null;
  bagNumber: string | null;
  bagTaskNumber: string | null;
  destinationWarehouseId: number | null;
  orderSortingCode: string | null;
  truckingChannelProductId: string | null;
  loadingScanEventStatus: number | null;
  handoverEventStatus: number | null;
  destinationType: number | null;
  unloadingTaskWaypointId: number | null;
  unloadingTime: string | null;
  operatorUnloadingAccountId: number | null;
  createdAt: string | null;
  updatedAt: string | null;
  isDeleted: number | null;
  removeTime: string | null;
  operatorRemoveAccountId: number | null;
};

export type LoadingArchiveDetailFilter = {
  trackingNumber?: string;
  bagNumber?: string;
};

type PageMeta = {
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
};

export type LoadingArchiveTasksResponse = {
  opsToolTmsLoadingArchiveTasks: PageMeta & { content: LoadingArchiveTaskItem[] };
};

export type LoadingArchiveDetailsResponse = {
  opsToolTmsLoadingArchiveDetails: PageMeta & {
    /** 1-在线表（未归档） 2-归档表（已归档） */
    dataSource: number | null;
    content: LoadingOrderDetailItem[];
  };
};

export const LOADING_ARCHIVE_TASKS = gql`
  query OpsToolTmsLoadingArchiveTasks($filter: OpsTmsLoadingArchiveTaskFilterInput!, $pageRequest: PageRequestTypeInput) {
    opsToolTmsLoadingArchiveTasks(filter: $filter, pageRequest: $pageRequest) {
      content {
        id
        taskNumber
        routeName
        taskType
        businessType
        taskDate
        taskStatus
        archiveStatus
        archivable
        notArchivableReason
        riskyArchive
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export const LOADING_ARCHIVE_DETAILS = gql`
  query OpsToolTmsLoadingArchiveDetails(
    $taskId: Long!
    $filter: OpsTmsLoadingArchiveDetailFilterInput
    $pageRequest: PageRequestTypeInput
  ) {
    opsToolTmsLoadingArchiveDetails(taskId: $taskId, filter: $filter, pageRequest: $pageRequest) {
      dataSource
      content {
        id
        tmsLoadingDetailId
        taskId
        waypointId
        loadingTime
        bagId
        orderId
        trackingNumber
        bagNumber
        bagTaskNumber
        destinationWarehouseId
        orderSortingCode
        truckingChannelProductId
        loadingScanEventStatus
        handoverEventStatus
        destinationType
        unloadingTaskWaypointId
        unloadingTime
        operatorUnloadingAccountId
        createdAt
        updatedAt
        isDeleted
        removeTime
        operatorRemoveAccountId
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;
